/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseFieldVisibilityRule } from './DatabaseFieldVisibilityRule';
import {
    DatabaseFieldVisibilityRuleFromJSON,
    DatabaseFieldVisibilityRuleFromJSONTyped,
    DatabaseFieldVisibilityRuleToJSON,
} from './DatabaseFieldVisibilityRule';
import type { DatabaseFontSizeEnum } from './DatabaseFontSizeEnum';
import {
    DatabaseFontSizeEnumFromJSON,
    DatabaseFontSizeEnumFromJSONTyped,
    DatabaseFontSizeEnumToJSON,
} from './DatabaseFontSizeEnum';
import type { DatabaseHeaderBlockActionType } from './DatabaseHeaderBlockActionType';
import {
    DatabaseHeaderBlockActionTypeFromJSON,
    DatabaseHeaderBlockActionTypeFromJSONTyped,
    DatabaseHeaderBlockActionTypeToJSON,
} from './DatabaseHeaderBlockActionType';
import type { DatabaseTextHeaderBlock } from './DatabaseTextHeaderBlock';
import {
    DatabaseTextHeaderBlockFromJSON,
    DatabaseTextHeaderBlockFromJSONTyped,
    DatabaseTextHeaderBlockToJSON,
} from './DatabaseTextHeaderBlock';

/**
 * 
 * @export
 * @interface DatabaseTitleHeaderBlock
 */
export interface DatabaseTitleHeaderBlock extends DatabaseTextHeaderBlock {
}

/**
 * Check if a given object implements the DatabaseTitleHeaderBlock interface.
 */
export function instanceOfDatabaseTitleHeaderBlock(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseTitleHeaderBlockFromJSON(json: any): DatabaseTitleHeaderBlock {
    return DatabaseTitleHeaderBlockFromJSONTyped(json, false);
}

export function DatabaseTitleHeaderBlockFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseTitleHeaderBlock {
    return json;
}

export function DatabaseTitleHeaderBlockToJSON(value?: DatabaseTitleHeaderBlock | null): any {
    return value;
}

